import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pages/invite/file.jpg'


const _withScopeId = n => (_pushScopeId("data-v-3623d56a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issueHoupiaoList__content" }
const _hoisted_2 = { class: "issueHoupiaoList__info clear" }
const _hoisted_3 = {
  style: {"width":"100%","margin-bottom":"15px","justify-content":"space-between"},
  class: "form_flex"
}
const _hoisted_4 = { class: "form_flex" }
const _hoisted_5 = { class: "info-wrap" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "个", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "元", -1))
const _hoisted_11 = { class: "list" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { style: {"margin-left":"10px"} }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routeTab = _resolveComponent("routeTab")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer withRouteTab issueHoupiaoList" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_routeTab),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form, {
              layout: "inline",
              class: "search_form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_form_item, { label: "支付时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _ctx.filterParams.payTimeRange,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.payTimeRange) = $event)),
                        format: "YYYY-MM-DD HH:mm:ss",
                        "show-time": { defaultValue: [_ctx.moment('00:00:00', 'HH:mm:ss'), _ctx.moment('23:59:59', 'HH:mm:ss')] },
                        placeholder: ['起始时间', '结束时间']
                      }, null, 8, ["value", "show-time"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "订单日期" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _ctx.filterParams.dateRange,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.dateRange) = $event)),
                        disabled: _ctx.filterParams.isAll,
                        format: "YYYY-MM-DD HH:mm:ss",
                        "show-time": { defaultValue: [_ctx.moment('00:00:00', 'HH:mm:ss'), _ctx.moment('23:59:59', 'HH:mm:ss')] },
                        onChange: _ctx.onChangeDate
                      }, null, 8, ["value", "disabled", "show-time", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.onExportList
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("导出列表")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, { label: "公司" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_app_enterprise_input, {
                        value: _ctx.filterParams.enterpriseId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.enterpriseId) = $event)),
                        object: _ctx.filterParams.enterprise,
                        "onUpdate:object": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.enterprise) = $event)),
                        style: {"width":"180px"}
                      }, null, 8, ["value", "object"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "部门" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tree_select, {
                        value: _ctx.filterParams.departmentId,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.departmentId) = $event)),
                        style: {"width":"180px"},
                        "allow-clear": "",
                        "show-search": "",
                        placeholder: "部门名称",
                        "search-placeholder": "请选择",
                        "show-line": true,
                        "tree-node-filter-prop": "title",
                        "tree-data": _ctx.departmentList
                      }, null, 8, ["value", "tree-data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "员工" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.filterParams.usercode,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterParams.usercode) = $event)),
                        style: {"width":"230px"},
                        placeholder: "请输入手机号或员工姓名",
                        "show-search": "",
                        "allow-clear": "",
                        "default-active-first-option": false,
                        "show-arrow": false,
                        "filter-option": false,
                        "not-found-content": null,
                        onSearch: _ctx.handleUserSearch
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.userCode,
                              value: item.userCode
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(`${item.userName}${(item.phone)}`), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onSearch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "车辆" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.filterParams.vehicleId,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterParams.vehicleId) = $event)),
                        style: {"width":"350px"},
                        placeholder: "请输入车牌号码或车辆唯一识别代码",
                        "show-search": "",
                        "allow-clear": "",
                        "default-active-first-option": false,
                        "show-arrow": false,
                        "filter-option": false,
                        "not-found-content": null,
                        onSearch: _ctx.handleVehicleSearch
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.id,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(`${item.licensePlate}${!item.vin ? '' : (item.licensePlate ? ' —— ' + item.vin : item.vin)}（${item.id}）`), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onSearch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "上传状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.filterParams.uploadInvoiceStatus,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterParams.uploadInvoiceStatus) = $event)),
                        style: {"width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("未上传")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("已上传")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "订单编号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.filterParams.orderNo,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterParams.orderNo) = $event)),
                        placeholder: "订单编号",
                        style: {"width":"200px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.filterParams.dateRange.length)
                ? (_openBlock(), _createBlock(_component_a_checkbox, {
                    key: 0,
                    checked: _ctx.checkedAll,
                    "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedAll) = $event)),
                    onChange: _ctx.handleCheckedAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(" 已上传发票订单数: "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.statistics.orderNum), 1),
                _hoisted_8,
                _createTextVNode(" 已开票金额: "),
                _createElementVNode("span", {
                  class: "amount",
                  innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.statistics.totalAmount))
                }, null, 8, _hoisted_9),
                _hoisted_10,
                _createVNode(_component_a_tooltip, { title: "已开票金额为员工上传发票的OCR结果的总和" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_icon, { type: "question" })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_tooltip, {
                visible: _ctx.actionTipVisible,
                "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.actionTipVisible) = $event)),
                placement: "top",
                title: "↖↖ 请先筛选要开票的订单"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    class: _normalizeClass(["info-wrap-button", { 'info-wrap-disabled': !_ctx.statistics.orderNum }]),
                    onClick: _ctx.onDownloadBatch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("批量导出发票")
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]),
          _createVNode(_component_app_table, {
            ref: "tableRef",
            size: "default",
            "row-key": "orderNo",
            columns: _ctx.tableColumns,
            data: _ctx.loadTableData,
            "row-selection": _ctx.checkedAll ? null : _ctx.selectState,
            scroll: { x: true }
          }, {
            operation: _withCtx(({ record }) => [
              _withDirectives(_createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.onInvoiceDetail(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情")
                ]),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, record.invoiceFileUrl]
              ])
            ]),
            _: 1
          }, 8, ["columns", "data", "row-selection"])
        ]),
        _createVNode(_component_a_modal, {
          title: "最近导出记录",
          visible: _ctx.exportVisible,
          footer: null,
          width: "500px",
          onCancel: _ctx.onCloseExportList
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "list_item"
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.fileName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    (item.status === 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("导出中，请稍后")
                        ], 64))
                      : (item.status === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" 导出成功， "),
                            _createElementVNode("a", {
                              target: "_self",
                              href: item.fileUrl
                            }, "点击下载", 8, _hoisted_14)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("导出失败，请重新导出")
                          ], 64))
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible", "onCancel"]),
        _createVNode(_component_a_modal, {
          visible: _ctx.previewVisible,
          footer: null,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.previewVisible = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "",
              style: {"width":"100%"},
              src: _ctx.previewImage
            }, null, 8, _hoisted_15)
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    _: 1
  }))
}